import { CircularProgress } from '@/components/feedback/CircularProgress/CircularProgress';
import { GlobalLoaderBackdrop } from '@/components/feedback/GlobalLoader/GlobalLoader.styles';

type GlobalLoaderProps = {
  status?: boolean;
  invisible?: boolean;
};

export const GlobalLoader = ({ status = true, invisible = false }: GlobalLoaderProps) => {
  if (!status) return;

  return (
    <GlobalLoaderBackdrop open invisible={invisible}>
      <CircularProgress size="4rem" data-testid="GlobalLoader" />
    </GlobalLoaderBackdrop>
  );
};
